// extracted by mini-css-extract-plugin
export default {"container":"b0-z","heading":"c0-z","links":"d0-z","copy":"e0-z","subCopy":"f0-z","linksLeft":"g0-z","linksCenter":"h0-z","linksRight":"i0-z","link":"j0-z","onlyLink":"k0-z"};